/** Leaf inputs whose stable identity comes from rk("value") or label text (e.g. buttons, checkboxes). */

export interface InputWithItemValue<TValue> {
  getItemValue(): NonNullable<TValue>;
}

export function isInputWithItemValue<TValue>(
  input: unknown,
): input is InputWithItemValue<TValue> {
  return (
    typeof input === "object" &&
    input !== null &&
    "getItemValue" in input &&
    typeof input.getItemValue === "function"
  );
}
